module.exports = __webpack_public_path__ + "static/card-organize-dont-8991d5ed31873d420472a34fd24b3447.png";